import axios from 'axios'
import router from '../router'

/* axios.defaults.params = {
  c: Date.now()
} */
axios.interceptors.request.use(config => {
  const separator = config.url.indexOf('?') === -1 ? '?' : '&'
  config.url = config.url + separator + 'c=' + Date.now()
  return config
}, error => Promise.reject(error))

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status && error.response.status.toString() === '401') {
    router.push({ name: 'page-not-found' })
  }
  return Promise.reject(error)
})
